export class WebhookV1StandardPayloadIssueMuted {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadIssueMutedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadIssueMutedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadIssueMuted.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadIssueMutedTypeEnum;
(function (WebhookV1StandardPayloadIssueMutedTypeEnum) {
    WebhookV1StandardPayloadIssueMutedTypeEnum["MutedOnResource"] = "ISSUE_MUTED_ON_RESOURCE";
    WebhookV1StandardPayloadIssueMutedTypeEnum["UnmutedOnResource"] = "ISSUE_UNMUTED_ON_RESOURCE";
})(WebhookV1StandardPayloadIssueMutedTypeEnum || (WebhookV1StandardPayloadIssueMutedTypeEnum = {}));
